import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Provider, useDispatch, useSelector } from "react-redux"
import GlobalStyle from "../styles/globalStyle"
import { store } from "./store"
import { HelmetProvider } from "react-helmet-async"
import Home from "../features/Home"
import ObservationsList from "../features/observations/ObservationsList"
import Observation from "../features/observations/Observation"
import ScheduledObservationsList from "../features/scheduled-observations/ScheduledObservationsList"
import { ThemeProvider } from "styled-components"
import theme from "../ui/theme"
import CollectionsList from "../features/collections/CollectionsList"
import RSO from "../features/rsos/RSO"
import RSOList from "../features/rsos/RSOList"
import Astrosite from "../features/astrosites/Astrosite"
import AstrositeList from "../features/astrosites/AstrositeList"
import Collection from "../features/collections/Collection"
import Schedule from "../features/schedules/Schedule"
import Dashboard from "../features/dashboard/Dashboard"
import Schedules from "../features/schedules/Schedules"
import SchedulesList from "../features/schedules/SchedulesList"
import SamplesSelection from "../features/data-submissions/SamplesSelection"
import SubmissionsList from "../features/data-submissions/SubmissionsList"
import Submission from "../features/data-submissions/Submission"
import PassesList from "../features/passes/PassesList"
import PriorityList from "../features/priorities/PriorityList"
import PrioritiesLists from "../features/priorities/PrioritiesLists"
import ScheduleDashboard from "../features/playlists/ScheduleDashboard"
import NotFound from "../features/NotFound"
import UserAccountsList from "../features/iam/UserAccountsList"
import UserAccount from "../features/iam/UserAccount"
import ActionsList from "../features/audit/ActionsList"
import Login from "../features/iam/Login"
import AuthRequired from "../features/iam/AuthRequired"
import Profile from "../features/iam/Profile"
import Support from "../features/support/Support"
import Playlist from "../features/playlists/Playlist"
import Playlists from "../features/playlists/Playlists"
import AccessLogList from "../features/iam/AccessLogList"
import { fetchAstrosites } from "../features/astrosites/slice"

import { selectAuth } from "../features/iam/slice"
function App({ basePath }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <HelmetProvider>
        <Provider store={store}>
          <AuthRequired>
            <BrowserRouter basename={basePath}>
              <AppRoutes />
            </BrowserRouter>
          </AuthRequired>
        </Provider>
      </HelmetProvider>
    </ThemeProvider>
  )
}

App.propTypes = {
  basePath: PropTypes.string,
}

const AppRoutes = () => {
  const { sub } = useSelector(selectAuth)
  // Core entity: Almost everything needs this available in state
  // Note: We couple the side effect to one's login status, so as to also fire
  // it off in the case where the user is first asked to log in
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(
      fetchAstrosites({
        filter: {
          sort_by: "id",
          sort_order: "ASC",
        },
        page: { offset: 0, limit: 100 },
        context: ["root"],
      })
    )
  }, [sub])
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/support" element={<Support />} />
      <Route path="/schedules/:id" element={<Schedule />} />
      <Route path="/schedules/all" element={<SchedulesList />} />
      <Route path="/schedules/*" element={<Schedules />} />
      <Route
        path="/scheduled/observations/*"
        element={<ScheduledObservationsList />}
      />
      <Route path="/observations/:id" element={<Observation />} />
      <Route path="/observations/*" element={<ObservationsList />} />
      <Route path="/collections/:id" element={<Collection />} />
      <Route path="/collections/*" element={<CollectionsList />} />
      <Route path="/rsos/:id" element={<RSO />} />
      <Route path="/rsos/*" element={<RSOList />} />
      <Route path="/astrosites/:id" element={<Astrosite />} />
      <Route path="/astrosites/*" element={<AstrositeList />} />
      <Route path="/passes/*" element={<PassesList />} />
      <Route path="/data-submissions/:id" element={<Submission />} />
      <Route path="/data-submissions/*" element={<SubmissionsList />} />
      <Route path="/priorities/:id" element={<PriorityList />} />
      <Route path="/priorities/*" element={<PrioritiesLists />} />
      <Route path="/accounts/:id" element={<UserAccount />} />
      <Route path="/accounts/*" element={<UserAccountsList />} />
      <Route path="/accounts/access-logs/*" element={<AccessLogList />} />
      <Route path="/actions/*" element={<ActionsList />} />
      <Route path="/playlists/:id" element={<Playlist />} />
      <Route path="/playlists/*" element={<Playlists />} />
      <Route path="/playlists/deploy-manual" element={<ScheduleDashboard />} />
      <Route
        path="/data-submissions/selection"
        element={<SamplesSelection />}
      />
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
export default App
